import { captureMessage } from '@sentry/browser';

export default {
  fromVueInstance: (err, vm, info) => {
    captureMessage(`${err.stack}\n${info}`);
  }
};
